module.exports = __webpack_public_path__ + "media/img/help_center/Student_Test_04-fcc9006e5c7f63e3283588804c49addf.jpg";